export const FORM_IDS = {
  CREATE: "create-warehouse-form",
  EDIT: "edit-warehouse-form",
  DELETE: "delete-warehouse-form",
};
